import type { FC } from 'react';
import { memo } from 'react';

import { Box } from '@mui/material';

import { TrashIcon } from '@setup/svg-icons/svg-icons';
import { BaseActionMenu, MuiIconButton } from 'shared/ui-kit';

import { ActionMenuContainer, CoverChip, CoverText } from '../AttachmentsItemCard/AttachmentsItemCard.style';

import type { ActionMenuListModel } from '@shared/models/actionMenuList.model';
import type { MediaType } from '@shared/models/media.model';
import type { AttachmentsProps } from 'shared/ui-kit';

type AttachmentActionsPropsType = {
  attachmentsItem: MediaType;
  actionMenu: ActionMenuListModel;
  deleteAttachmentHandler: () => void;
  isCanDelete?: boolean;
} & Pick<AttachmentsProps, 'isShowActionMenu' | 'isShowCoverPhoto'>;
export const AttachmentActions: FC<AttachmentActionsPropsType> = memo((props) => {
  const {
    isShowActionMenu,
    isShowCoverPhoto,
    actionMenu,
    attachmentsItem,
    isCanDelete,
    deleteAttachmentHandler,
  } = props;

  return (
    <>
      {isCanDelete && !isShowActionMenu && (
        <Box className="attachment-icon-btn" id="deleteAttachmentButton">
          <MuiIconButton onClick={deleteAttachmentHandler} size="small" withBackdropFilter>
            <TrashIcon />
          </MuiIconButton>
        </Box>
      )}

      {isShowActionMenu && (
        <Box className="action-menu-btn">
          <ActionMenuContainer>
            <BaseActionMenu withBackdropFilter disablePortal={false} menuList={actionMenu} />
          </ActionMenuContainer>
        </Box>
      )}

      {isShowCoverPhoto && attachmentsItem.is_cover && (
        <CoverChip>
          <CoverText variant="s3">Cover</CoverText>
        </CoverChip>
      )}
    </>
  );
});
